module.exports = __webpack_public_path__ + "img/SPANK.6e0e135e.svg";